module.exports = __webpack_public_path__ + "img/az_quanqiugou_logo.2827a8e9.png";